import { WarningCircle } from '@phosphor-icons/react';

export default WarningCircle;
